import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51342ddd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "progress-graph-container" }
const _hoisted_2 = { class: "progress-graph-status-text" }
const _hoisted_3 = { class: "progress-graph-status-text" }
const _hoisted_4 = { class: "progress-graph-status-text" }
const _hoisted_5 = { class: "progress-graph-status-text" }
const _hoisted_6 = { class: "progress-graph-status-text" }

import { IChecklistRequested } from "@/interfaces/vendor";
import { checklistRequestedStatusId } from "@/utils/constants";
import { getComponentUiText } from "@/utils/utilities";
import { onMounted, PropType, ref, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'progressGraph',
  props: {
  details: { type: Object as PropType<IChecklistRequested>, required: true },
},
  setup(__props) {

const props = __props;

const createdClass = ref("");
const sentClass = ref("");
const withVendorClass = ref("");
const readyClass = ref("");
const completedClass = ref("");
// Created - new
// Sent - wait
// With vendor - inprog
// Ready to review - submit
// Completed - done


onMounted(() => {
  checkStatus(props.details.statusId, props.details.isArchived);
});

watch(
  () => props.details,
  (newStatus) => {
    checkStatus(newStatus.statusId, newStatus.isArchived);
  },
  { deep: true },
);
const checkStatus = (status: string, isArchived: boolean) => {
  if (isArchived) {
    createdClass.value = "";
    sentClass.value = "";
    withVendorClass.value = "";
    readyClass.value = "";
    completedClass.value = "";
    return;
  }
  switch (status) {
    case checklistRequestedStatusId.created:
      createdClass.value = "status-progress";
      sentClass.value = "";
      withVendorClass.value = "";
      readyClass.value = "";
      completedClass.value = "";
      break;
    case checklistRequestedStatusId.waiting:
      createdClass.value = "status-progress active-divide";
      sentClass.value = "status-progress";
      withVendorClass.value = "";
      readyClass.value = "";
      completedClass.value = "";
      break;
    case checklistRequestedStatusId.inProgress:
      createdClass.value = "status-progress active-divide";
      sentClass.value = "status-progress active-divide";
      withVendorClass.value = "status-progress";
      readyClass.value = "";
      completedClass.value = "";
      break;
    case checklistRequestedStatusId.submitted:
      createdClass.value = "status-progress active-divide";
      sentClass.value = "status-progress active-divide";
      withVendorClass.value = "status-progress active-divide";
      readyClass.value = "status-progress";
      completedClass.value = "";
      break;
    case checklistRequestedStatusId.completed:
      createdClass.value = "status-progress active-divide";
      sentClass.value = "status-progress active-divide";
      withVendorClass.value = "status-progress active-divide";
      readyClass.value = "status-progress active-divide";
      completedClass.value = "status-completed";
      break;
    default:
      break;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["progress-graph", createdClass.value])
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(getComponentUiText)("app-progress-graph-created-1")), 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["progress-graph", sentClass.value])
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getComponentUiText)("app-progress-graph-sent-1")), 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["progress-graph", withVendorClass.value])
    }, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)("app-progress-graph-inprog-1")), 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["progress-graph", readyClass.value])
    }, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getComponentUiText)("app-progress-graph-review-1")), 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["progress-graph", completedClass.value])
    }, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(getComponentUiText)("app-progress-graph-completed-1")), 1)
    ], 2)
  ]))
}
}

})